/**
 * Augmented Chess Engine - Main Entry Point
 *
 * @packageDocumentation
 */

// Appliers
export * from "./appliers/index";

// Augmentations
export * from "./augmentations/index";

// Initialization
export { createInitialState, initGame } from "./init-game";
// Validate-then-apply wrapper
export { type ApplyActionResult, tryApplyAction } from "./try-apply-action";
// Types
export * from "./types/index";
// Utilities
export * from "./utils/index";
// Validators
export * from "./validators/index";
